/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vue Monica Refine Design
  Author: Riyan Kurniawan
  -- MONICA --
==========================================================================================*/

import Vue from 'vue'
import Router from 'vue-router'
// import auth from "@/auth/authService";
import auth from './repository/auth'

import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          redirect: '/dashboard/analytics',
        },
        {
          path: '/dashboard',
          redirect: '/dashboard/analytics',
        },
        {
          path: '/page/dashboard-analytic',
          name: 'Dashboard',
          component: () => import('./views/dashboard/v2/Dashboard.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Dashboard Analytics', active: true },
            ],
            pageTitle: 'Dashboard Analytics',
            rule: 'editor',
          },
        },
        {
          path: '/page/dashboard-analytic-dms',
          name: 'dashboardAnalyticsDMS',
          component: () => import('./views/dashboard/v2/AnalyticsDMS.vue'),
        },
        {
          path: '/dashboard/analytics',
          name: 'dashboardAnalytics',
          component: () => import('./views/DashboardAnalytics.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Dashboard', active: true },
            ],
            pageTitle: 'Dashboard',
            rule: 'editor',
          },
        },
        // {
        //   path: '/dashboard/analytics',
        //   name: 'dashboardAnalytics',
        //   component: () => import('./views/DashboardAnalytics.vue'),
        //   meta: {
        //     pageTitle: 'Dashboard',
        //     rule: 'editor',
        //   },
        // },
        {
          path: '/master-data/mapping-geofence',
          name: 'geofence',
          component: () => import('@/views/master-data/geofence/Mapping.vue'),
          meta: {
            title: 'Customer Dashboard - Geofence Mapping ',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Master Data' },
              { title: 'Mapping Geofence', active: true },
            ],
            pageTitle: 'Geofence Mapping',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/geofence-category',
          name: 'geofence',
          component: () =>
            import('@/views/master-data/geofence/GeofenceCategory.vue'),
          meta: {
            title: 'Customer Dashboard - Geofence Type',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Master Data' },
              { title: 'Geofence Type', active: true },
            ],
            pageTitle: 'Geofence Categories',
            rule: 'admin',
          },
        },
        // {
        //   path: '/master-data/geofence-category/add-new',
        //   name: 'geofence',
        //   component: () => import('@/views/master-data/geofence/GeofenceCategoryForm.vue'),
        //   meta: {
        //     title: 'Customer Dashboard - Geofence Type - Add New',
        //     // breadcrumb: [
        //       // { title: 'Home', url: '/' },
        //       // { title: 'Master Data' },
        //       // { title: 'Geofence Type', active: true },
        //     // ],
        //     // pageTitle: 'Geofence Categories',
        //     rule: 'admin',
        //   },
        // },
        {
          path: '/users/users-management',
          name: 'users',
          component: () => import('@/views/users/Users.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Users Management', active: true },
            ],
            pageTitle: 'User Management',
            rule: 'admin',
          },
        },
        {
          path: '/investigasi',
          name: 'investigasi',
          component: () => import('@/views/investigasi/Investigasi.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Investigasi', active: true },
            ],
            pageTitle: 'Investigation',
            rule: 'admin',
          },
        },
        {
          path: '/investigasi/bookmark',
          name: 'investigasiBookmark',
          component: () => import('@/views/investigasi/BookmarkInvestigasi.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Investigasi', url: '/investigasi' },
              { title: 'Bookmark', active: true },
            ],
            pageTitle: 'Bookmark Investigasi',
            rule: 'admin',
          },
        },
        {
          path: '/investigasi/history',
          name: 'investigasiHistory',
          component: () => import('@/views/investigasi/InvestigationHistory.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Investigasi', url: '/investigasi' },
              { title: 'History', active: true },
            ],
            pageTitle: 'Investigation History',
            rule: 'admin',
          },
        },
        {
          path: '/investigasi/history/detail/:id',
          name: 'investigasiHistoryDetail',
          component: () => import('@/views/investigasi/InvestigationDetail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Investigasi', url: '/investigasi' },
              { title: 'History', url: '/investigasi/history' },
              { title: 'Detail', active: true },
            ],
            pageTitle: 'Investigation History',
            rule: 'admin',
          },
        },
        {
          path: '/monitoring',
          name: 'monitoring',
          component: () => import('@/views/monitoring/Monitoring.vue'),
          meta: {
            // breadcrumb: [
            //     { title: 'Home', url: '/' },
            //     { title: 'Monitoring', active: true },
            // ],
            // pageTitle: 'Monitoring',
            rule: 'admin',
          },
        },
        {
          path: '/page/report',
          name: 'report',
          component: () => import('@/views/report/Report.vue'),
          meta: {
            // breadcrumb: [
            //     { title: 'Home', url: '/' },
            //     { title: 'Report', active: true },
            // ],
            // pageTitle: 'Report',
            rule: 'admin',
          },
        },
        {
          path: '/page/dashboard-analytic',
          name: 'analytics',
          component: () => import('@/views/dashboard-analytics/Analytics.vue'),
          meta: {
            // breadcrumb: [
            //     { title: 'Home', url: '/' },
            //     { title: 'Report', active: true },
            // ],
            // pageTitle: 'Report',
            rule: 'admin',
          },
        },
        {
          path: '/monitoring-vehicle/:id',
          name: 'monitoringView',
          component: () => import('@/views/monitoring/MonitoringView.vue'),
          meta: {
            // breadcrumb: [
            //     { title: 'Home', url: '/' },
            //     { title: 'Cluster Monitoring', url: '/monitoring' },
            //     { title: 'Monitoring Vehicle', active: true },
            // ],
            // pageTitle: 'Monitoring Vehicle',
            rule: 'admin',
          },
        },
        {
          path: '/playback-vehicle/:id',
          name: 'playbackView',
          component: () => import('@/views/monitoring/MonitoringPlayBack.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Cluster Monitoring', url: '/monitoring' },
              { title: 'Playback', active: true },
            ],
            pageTitle: 'Playback',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/geofence-mapping-view/:id',
          name: 'geofenceView',
          component: () =>
            import('@/views/master-data/geofence/MappingGeofenceData.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              {
                title: 'Geofence Mapping',
                url: '/master-data/geofence-mapping',
              },
              { title: 'View Detail', active: true },
            ],
            pageTitle: 'Geofence Mapping Detail',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/geofence-detail',
          name: 'geofenceDetail',
          component: () =>
            import('@/views/master-data/geofence/GeofenceData.vue'),
          meta: {
            rule: 'admin',
          },
        },
        {
          path: '/master-data/geofence-detail-update/:id',
          name: 'geofenceDetailUpdate',
          component: () =>
            import('@/views/master-data/geofence/GeofenceDataUpdate.vue'),
          meta: {
            rule: 'admin',
          },
        },
        // =============================================================================
        // Master Data
        // =============================================================================
        {
          path: '/master-data/fleet-group',
          name: 'masterDataFleetGroup',
          component: () =>
            import('@/views/master-data/fleet-group/FleetGroup.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Master Data' },
              { title: 'Fleet Group', active: true },
            ],
            pageTitle: 'Fleet Group',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/poi',
          name: 'masterDataPoi',
          component: () => import('@/views/poi/POI.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Master Data' },
              { title: 'Point of Interest (POI)', active: true },
            ],
            pageTitle: 'Point of Interest (POI)',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/category-poi',
          name: 'masterDataPoi',
          component: () => import('@/views/poi/POI-Category.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Master Data' },
              { title: 'Point of Interest (POI) Category', active: true },
            ],
            pageTitle: 'Point of Interest (POI) Category',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/alert',
          name: 'masterDataAlert',
          component: () => import('@/views/master-data/alert/Alert.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Master Data' },
              { title: 'Alert', active: true },
            ],
            pageTitle: 'Alert',
            rule: 'admin',
          },
        },
        {
          path: '/alert-history',
          name: 'alertHistory',
          component: () => import('@/views/master-data/alert/AlertHistory.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Alert History', active: true },
            ],
            pageTitle: 'Alert History',
            rule: 'admin',
          },
        },
        {
          path: '/alert-mutation',
          name: 'alertMutation',
          component: () =>
            import('@/views/master-data/alert-mutasi/AlertMutation.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Alert Mutation', active: true },
            ],
            pageTitle: 'Alert Mutation',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/vehicle-provisioning',
          name: 'vehicleProvisioning',
          component: () =>
            import('@/views/master-data/vehicle/ProvisioningList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Master Data' },
              { title: 'Vehicle Provisioning', active: true },
            ],
            pageTitle: 'Vehicle Provisioning',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/vehicle-driver',
          name: 'vehicleDriver',
          component: () => import('@/views/master-data/vehicle/Driver.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Master Data' },
              { title: 'Vehicle Driver', active: true },
            ],
            pageTitle: 'Vehicle Driver',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/vehicle-replacement',
          name: 'vehicleReplacement',
          component: () =>
            import(
              '@/views/master-data/vehicle-replacement/VehicleReplacement.vue'
            ),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Master Data' },
              { title: 'Vehicle Replacement', active: true },
            ],
            pageTitle: 'Vehicle Replacement',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/vehicle-replacement-bulk',
          name: 'vehicleReplacementBulk',
          component: () =>
            import(
              '@/views/master-data/vehicle-replacement/VehicleReplacementBULK.vue'
            ),
          meta: {
            rule: 'admin',
          },
        },
        {
          path: '/master-data/vehicle-provisioning-bulk',
          name: 'vehicleProvisioningBulk',
          component: () =>
            import('@/views/master-data/vehicle/VehicleProvisioningBULK.vue'),
          meta: {
            rule: 'admin',
          },
        },
        {
          path: '/master-data/vehicle-update-bulk',
          name: 'vehicleUpdateBulk',
          component: () =>
            import('@/views/master-data/vehicle/VehicleUpdateBULK.vue'),
          meta: {
            rule: 'admin',
          },
        },
        {
          path: '/master-data/vehicle-dismantle-bulk',
          name: 'vehicleDismantleBulk',
          component: () =>
            import('@/views/master-data/vehicle/VehicleDismantleBULK.vue'),
          meta: {
            rule: 'admin',
          },
        },
        {
          path: '/master-data/vehicle-shipment',
          name: 'vehicleShipment',
          component: () =>
            import('@/views/master-data/vehicle/VehicleShipment.vue'),
          meta: {
            rule: 'admin',
          },
        },
        {
          path: '/master-data/geofence',
          name: 'geofence',
          component: () => import('@/views/master-data/geofence/Geofence.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Master Data' },
              { title: 'Geofence', active: true },
            ],
            pageTitle: 'Master Geofence',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/mapping-alert',
          name: 'masterDataAlertMapping',
          component: () =>
            import('@/views/master-data/alert-mapping/AlertMapping.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Master Data' },
              { title: 'Alert Mapping', active: true },
            ],
            pageTitle: 'Alert Mapping',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/summary-alert',
          name: 'masterDataAlertSummary',
          component: () =>
            import('@/views/master-data/alert-summary/AlertSummary.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Master Data' },
              { title: 'Alert Summary', active: true },
            ],
            pageTitle: 'Alert Summary',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/master-report',
          name: 'masterReport',
          component: () =>
            import('@/views/master-data/report-master/ReportMaster.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Master Data' },
              { title: 'Report Master', active: true },
            ],
            pageTitle: 'Report Param Master',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/report-mapping',
          name: 'reportMapping',
          component: () =>
            import('@/views/master-data/report-mapping/ReportMapping.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Master Data' },
              { title: 'Report Mapping', active: true },
            ],
            pageTitle: 'Report Mapping',
            rule: 'admin',
          },
        },
        {
          path: '/auth/menu-configuration',
          name: 'menuConfiguration',
          component: () => import('@/views/auth/menus/Menus.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Authorization' },
              { title: 'Menu Configuration', active: true },
            ],
            pageTitle: 'Menu Configuration',
            rule: 'admin',
          },
        },
        {
          path: '/users/role-management',
          name: 'roleManagement',
          component: () => import('@/views/auth/roles/Roles.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Authorization' },
              { title: 'Role Management', active: true },
            ],
            pageTitle: 'Role Management',
            rule: 'admin',
          },
        },
        {
          path: '/system/backup-link',
          name: 'BackupLink',
          component: () => import('@/views/backuplink/BackupLink.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'System' },
              { title: 'Backup Link', active: true },
            ],
            pageTitle: 'Backup Link',
            rule: 'admin',
          },
        },

        // =============================================================================
        // Configurations
        // =============================================================================
        {
          path: '/config/vehicle-brand',
          name: 'VehicleBrand',
          component: () =>
            import('@/views/configurations/vehicle/VehicleBrand.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Configurations' },
              { title: 'Vehicle Brand', active: true },
            ],
            pageTitle: 'Vehicle Brand',
            rule: 'admin',
          },
        },
        {
          path: '/config/vehicle-model',
          name: 'VehicleModel',
          component: () =>
            import('@/views/configurations/vehicle/VehicleModel.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Configurations' },
              { title: 'Vehicle Model', active: true },
            ],
            pageTitle: 'Vehicle Model',
            rule: 'admin',
          },
        },
        {
          path: '/config/alert-list',
          name: 'AlertList',
          component: () => import('@/views/master-data/alert/AlertList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Configurations' },
              { title: 'Alert List', active: true },
            ],
            pageTitle: 'Alert List',
            rule: 'admin',
          },
        },

        // =============================================================================
        // Export
        // =============================================================================
        {
          path: '/export',
          name: 'Export',
          component: () => import('@/views/export/Export.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Export', active: true },
            ],
            pageTitle: 'Export Data',
            rule: 'admin',
          },
        },
        {
          path: '/export/history',
          name: 'Export History',
          component: () => import('@/views/export/ExportHistory.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Export' },
              { title: 'History', active: true },
            ],
            pageTitle: 'Export History',
            rule: 'admin',
          },
        },

        // =============================================================================
        // Pages Routes
        // =============================================================================
        {
          path: '/pages/profile',
          name: 'pageProfile',
          component: () => import('@/views/pages/Profile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'Profile', active: true },
            ],
            pageTitle: 'Profile',
            rule: 'editor',
          },
        },

        {
          path: '/pages/invoice',
          name: 'pageInvoice',
          component: () => import('@/views/pages/Invoice.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'Invoice', active: true },
            ],
            pageTitle: 'Invoice',
            rule: 'editor',
          },
        },
        // =============================================================================
        // POI Data
        // =============================================================================
        {
          path: '/master-data/poi-data/:id',
          name: 'POIData',
          component: () => import('@/views/poi/POIData.vue'),
          meta: {
            // breadcrumb: [
            //     { title: 'Home', url: '/' },
            //     { title: 'Master Data' },
            //     { title: 'Point of Interest (POI)', active: true },
            // ],
            // pageTitle: 'Point of Interest (POI)',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/poi-detail/:id',
          name: 'masterDataPoiDetail',
          component: () => import('@/views/poi/POIDetail.vue'),
          meta: {
            // breadcrumb: [
            //   { title: 'Home', url: '/' },
            //   { title: 'Master Data' },
            //   { title: 'Point of Interest (POI)' },
            //   { title: 'POI Detail', active: true },
            // ],
            // pageTitle: 'POI Detail',
            rule: 'admin',
          },
        },
        {
          path: '/master-data/poi-detail-update/:id',
          name: 'poiDetailUpdate',
          component: () => import('@/views/poi/POIDataUpdate.vue'),
          meta: {
            rule: 'admin',
          },
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/playground',
          name: 'playground',
          component: () => import('@/views/Playground.vue'),
          meta: {
            pageTitle: 'Playground',
            rule: 'editor',
          },
        },
        {
          path: '/callback',
          name: 'authCallback',
          component: () => import('@/views/Callback.vue'),
          meta: {
            rule: 'editor',
          },
        },
        {
          path: '/system/backup-link-external',
          name: 'BackupLinkExternal',
          component: () => import('@/views/backuplink/BackupLinkExternal.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'System' },
              { title: 'Backup Link', active: true },
            ],
            pageTitle: 'Backup Link',
            rule: 'admin',
          },
        },
        {
          path: '/pages/login',
          name: 'pageLogin',
          component: () => import('@/views/pages/Login.vue'),
          meta: {
            pageTitle: 'Login',
            rule: 'editor',
          },
        },
        {
          path: '/live-track/:token',
          name: 'monitoringSample',
          component: () => import('@/views/monitoring/MonitoringWebView.vue'),
          meta: {
            pageTitle: 'Monitoring',
            rule: 'editor',
          },
        },
        {
          path: '/preview/mettax/:content(.*)',
          name: 'monitoringNoAuthSample',
          // component: () =>import('@/views/monitoring/MonitoringNoAuthWebView.vue'),
          component: () =>import('@/views/preview/MettaxPreview.vue'),
          meta: {
            pageTitle: 'Evidence Preview',
            rule: 'editor',
          },
          pathToRegexpOptions: { strict: false }
        },
        {
          path: '/pages/periodic/:start/:end/:license_plate/:token',
          name: 'periodic',
          component: () =>
            import('@/views/monitoring/MonitoringPlayBackWebView.vue'),
          meta: {
            pageTitle: 'Periodic',
            rule: 'editor',
          },
        },
        {
          path: '/pages/register',
          name: 'pageRegister',
          component: () => import('@/views/pages/Register.vue'),
          meta: {
            rule: 'editor',
          },
        },
        {
          path: '/pages/forgot-password',
          name: 'pageForgotPassword',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'editor',
          },
        },
        {
          path: '/pages/reset-password',
          name: 'pageResetPassword',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
            rule: 'editor',
          },
        },
        {
          path: '/pages/activate-password/:id',
          name: 'pageResetPassword2',
          component: () => import('@/views/auth/pages/ActivateUser.vue'),
          meta: {
            rule: 'editor',
          },
        },
        {
          path: '/pages/reset-password/:id',
          name: 'pageResetPassword3',
          component: () => import('@/views/auth/pages/ResetPassword.vue'),
          meta: {
            rule: 'editor',
          },
        },
        {
          path: '/pages/lock-screen',
          name: 'pageLockScreen',
          component: () => import('@/views/pages/LockScreen.vue'),
          meta: {
            rule: 'editor',
          },
        },

        {
          path: '/pages/error-404',
          name: 'pageError404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor',
          },
        },
        {
          path: '/pages/error-500',
          name: 'pageError500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor',
          },
        },
        {
          path: '/pages/not-authorized',
          name: 'pageNotAuthorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor',
          },
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404',
    },
  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  let menus = localStorage.getItem('userInfo')

  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.pageTitle)
  if (nearestWithTitle) document.title = 'BITRACK - ' + to.meta.pageTitle
  let ada = []
  if (menus) {
    let menus_tmp = JSON.parse(menus)

    if (menus_tmp.role) {
      let rolenya = menus_tmp.role.role_menu
      // (rolenya);
      let pathnya = to.path
      if (to.path.substring(0, 20) === '/monitoring-vehicle/') {
        pathnya = '/monitoring-vehicle/'
      }
      if (to.path.substring(0, 35) === '/master-data/geofence-mapping-view/') {
        pathnya = '/master-data/geofence-mapping-view/'
      }
      if (to.path.substring(0, 36) === '/master-data/geofence-detail-update/') {
        pathnya = '/master-data/geofence-detail-update/'
      }
      if (to.path.substring(0, 23) === '/master-data/poi-detail') {
        pathnya = '/master-data/poi-detail'
      }
      ada = rolenya.filter((x) => {
        return x.menu_link === pathnya
      })
    }
  }

  if (
    to.path === '/pages/login' ||
    to.path === '/pages/forgot-password' ||
    to.path === '/pages/error-404' ||
    to.path === '/pages/error-500' ||
    to.path === '/system/backup-link-external' ||
    to.path === '/pages/monitoring-no-auth-sample' ||
    to.path.startsWith('/live-track/') ||
    to.path.substring(0, 25) === '/pages/activate-password/' ||
    to.path.substring(0, 22) === '/pages/reset-password/' ||
    to.path.substring(0, 16) === '/pages/periodic/' ||
    to.path === '/pages/register' ||
    to.path === '/callback' ||
    to.path === '/pages/comingsoon' ||
    auth.isAuthenticated()
  ) {
    if (
      to.path === '/pages/login' ||
      to.path === '/pages/forgot-password' ||
      to.path === '/pages/error-404' ||
      to.path === '/pages/error-500' ||
      to.path === '/pages/dashboard/analytics' ||
      to.path === '/dashboard/analytics' ||
      to.path === '/system/backup-link-external' ||
      to.path === '/pages/monitoring-no-auth-sample' ||
      to.path.substring(0, 25) === '/pages/activate-password/' ||
      to.path.substring(0, 22) === '/pages/reset-password/' ||
      to.path.substring(0, 16) === '/pages/periodic/' ||
      to.path === '/pages/register' ||
      to.path === '/callback' ||
      to.path === '/pages/comingsoon' ||
      to.path === '/' ||
      ada.length > 0
    ) {
      return next()
    } else {
      return next()
      // router.push({ path: '/pages/error-404', query: { to: to.path } })
    }
    // if(ada.length>0 || to.path==='/'){

    // }else{
    //
    // }
  } else {
    auth.logOut()
    // sessionStorage.setItem('redirectAfterLogin', to.fullPath)
    const fullPath = decodeURIComponent(to.fullPath)
    sessionStorage.setItem('redirectAfterLogin', fullPath)
    router.push({ path: '/pages/login', query: { to: to.path } })
  }
  // firebase.auth().onAuthStateChanged(() => {
  //
  //     // get firebase current user
  //     const firebaseCurrentUser = firebase.auth().currentUser;
  //
  //
  //     // Specify the current path as the customState parameter, meaning it
  //     // will be returned to the application after auth
  //     // auth.login({ target: to.path });
  //
  // });
})

export default router
